module.exports = __webpack_public_path__ + "static/fonts/AlibabaPuHuiTi-2-85-Bold.07c596ce.ttf";